module.exports = __webpack_public_path__ + "static/AdelleSans-Light-f1e121f70429945d2653de2e836ecc63.woff";